import React, { Component } from 'react'
import { Form } from 'devextreme-react'
import { participants } from 'dataSource/lookup'
import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import { alert } from 'devextreme/ui/dialog'
import httpRequest from 'plugin/httprequest'

class LaporanIuranBulanan extends Component {
  constructor(props) {
    super(props)

    this.participantId = this.props.store.getState().sessionUser
      ? this.props.store.getState().sessionUser.participantId
      : 0

    this.state = {
      filterData: {},
    }

    this.resultData = []

    this.filterRef = React.createRef()
    this.dataGridRef = React.createRef()

    this.filterItems = [
      {
        dataField: 'participantId',
        colSpan: 2,
        label: {
          text: 'Pemberi Kerja',
        },
        editorType: 'dxSelectBox',
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
          dataSource: participants(this.props.store),
          valueExpr: 'id',
          displayExpr: 'participantName',
          value: this.participantId,
          readOnly: true,
        },
      },
      {
        itemType: 'empty',
      },
      {
        dataField: 'periode1',
        label: {
          text: 'Periode',
        },
        editorType: 'dxDateBox',
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          useMaskBehavior: true,
          width: '100%',
          displayFormat: 'MMM yyyy',
          openOnFieldClick: true,
          calendarOptions: {
            zoomLevel: 'year',
            maxZoomLevel: 'year',
          },
        },
      },
      {
        dataField: 'periode2',
        label: {
          text: 's/d',
        },
        editorType: 'dxDateBox',
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          useMaskBehavior: true,
          width: '100%',
          displayFormat: 'MMM yyyy',
          openOnFieldClick: true,
          calendarOptions: {
            zoomLevel: 'year',
            maxZoomLevel: 'year',
          },
        },
      },
      {
        dataField: 'filter',
        label: {
          visible: false,
        },
        editorType: 'dxButton',
        editorOptions: {
          text: 'Filter',
          elementAttr: { class: 'bg-button-popup-save-dapen-default' },
          onClick: async () => {
            await this.getData()
          },
        },
      },
    ]

    this.columns = [
      {
        dataField: 'no',
        caption: 'No',
        width: 50,
        alignment: 'center',
        cellRender: (data) => {
          return data.rowIndex + 1
        },
      },
      {
        dataField: 'productName',
        caption: 'Produk',
      },
      {
        dataField: 'jumPeserta',
        caption: 'Jumlah Peserta',
        dataType: 'number',
        format: '#,##0',
        alignment: 'right',
      },
      {
        dataField: 'jumIuran',
        caption: 'Total Iuran',
        dataType: 'number',
        format: '#,##0',
        alignment: 'right',
      },
      {
        dataField: 'invoiceNo',
        caption: 'No. Invoice',
      },
      {
        dataField: 'jumTagihan',
        caption: 'Jumlah Tagihan',
        dataType: 'number',
        format: '#,##0',
        alignment: 'right',
      },
    ]
  }

  getData = async () => {
    let { filterData } = this.state

    if (!filterData.periode1 || !filterData.periode2) {
      await alert('Periode tidak boleh kosong', 'Perhatian!')
      return null
    }

    const bulanLessThan = filterData.periode1.getMonth() + 1
    const tahunLessThan = filterData.periode1.getFullYear()
    const bulanGreatherThan = filterData.periode2.getMonth() + 1
    const tahunGreatherThan = filterData.periode2.getFullYear()

    const result = await httpRequest(
      process.env.REACT_APP_BACKEND_CORE,
      this.props.store,
      `view-pk-outstanding-iurans?bulan.greaterThanOrEqual=${bulanGreatherThan}&bulan.lessThanOrEqual=${bulanLessThan}&participantId.equals=${filterData.participantId}&tahun.greaterThanOrEqual=${tahunGreatherThan}&tahun.lessThanOrEqual=${tahunLessThan}`,
      'GET'
    )

    if (result.length > 0) {
      this.resultData = result
    }
    this.forceRefresh()
  }

  loadData = () => {
    return this.resultData
  }

  forceRefresh = () => {
    this.dataGridRef.current.forceRefresh(true)
  }

  render() {
    return (
      <div className="container-fluid">
        <h2 className="main-title">Iuran Bulanan</h2>
        <div className="row">
          <div className="col-6">
            <Form
              colCount={3}
              id={'formFilter'}
              formData={this.state.filterData}
              items={this.filterItems}
              ref={this.filterRef}
              labelLocation={'left'}
            />
          </div>
        </div>

        <DevExpressDataGrid
          ref={this.dataGridRef}
          loadAPI="-"
          insertAPI="-"
          updateAPI="-"
          deleteAPI="-"
          backendserver={process.env.REACT_APP_BACKEND_CORE}
          useArraySource={true}
          ArraySourceData={this.loadData}
          allowAdding={false}
          allowDeleting={false}
          allowUpdating={false}
          selection={'single'}
          showBorders={true}
          paging={true}
          defaultPageSize={10}
          height={'80vh'}
          ColumnChooser={true}
          ColumnFixing={true}
          FilterRow={true}
          ColumnConfiguration={this.columns}
          store={this.props.store}
        />
      </div>
    )
  }
}

export default LaporanIuranBulanan
